export default __webpack_public_path__ + "static/media/sign-up-lock.1495b2fb.svg";